import React, { useState } from "react";
import { Link } from "react-router-dom";

const Topbar: React.FC<{
  toogleHandler: () => void;
  signOutHandler: () => void;
}> = ({ toogleHandler, signOutHandler }) => {
  const [showSearch, setShowSearch] = useState<boolean>(false);

  const [showNotif, setShowNotif] = useState<boolean>(false);

  const [showProfile, setShowProfile] = useState<boolean>(false);

  return (
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
      {/* <!-- Sidebar Toggle (Topbar) --> */}
      <button
        id="sidebarToggleTop"
        onClick={toogleHandler}
        className="btn btn-link d-md-none rounded-circle mr-3"
      >
        <i className="fa fa-bars"></i>
      </button>

      {/* <!-- Topbar Search --> */}
      <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
        <div className="input-group">
          <input
            type="text"
            className="form-control bg-light border-0 small"
            placeholder="Search for..."
            aria-label="Search"
            aria-describedby="basic-addon2"
          />
          <div className="input-group-append">
            <button className="btn btn-primary" type="button">
              <i className="fas fa-search fa-sm"></i>
            </button>
          </div>
        </div>
      </form>

      {/* <!-- Topbar Navbar --> */}
      <ul className="navbar-nav ml-auto">
        {/* <!-- Nav Item - Search Dropdown (Visible Only XS) --> */}
        <li
          className={`nav-item dropdown no-arrow d-sm-none ${
            showSearch ? "show" : ""
          }`}
        >
          <button
            className="btn nav-link dropdown-toggle"
            onClick={() => setShowSearch(!showSearch)}
            // data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded={showSearch ? "true" : "false"}
          >
            <i className="fas fa-search fa-fw"></i>
          </button>
          {/* <!-- Dropdown - Messages --> */}
          <div
            className={`dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in ${
              showSearch ? "show" : ""
            }`}
            aria-labelledby="searchDropdown"
          >
            <form className="form-inline mr-auto w-100 navbar-search">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control bg-light border-0 small"
                  placeholder="Search for..."
                  aria-label="Search"
                  aria-describedby="basic-addon2"
                />
                <div className="input-group-append">
                  <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </li>

        {/* <!-- Nav Item - Alerts --> */}
        <li
          className={`nav-item dropdown no-arrow mx-1 ${
            showNotif ? "show" : ""
          }`}
        >
          <button
            style={{ marginTop: "20px" }}
            className="btn py-n2  h-50 nav-link dropdown-toggle "
            // id="alertsDropdown"

            aria-haspopup="true"
            aria-expanded={showNotif ? "true" : "false"}
            onClick={() => setShowNotif(!showNotif)}
          >
            <i className="fas fa-bell fa-fw"></i>
            {/* <!-- Counter - Alerts --> */}
            <span className="badge badge-danger badge-counter">3+</span>
          </button>
          {/* <!-- Dropdown - Alerts --> */}
          <div
            className={`dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in ${
              showNotif ? "show" : ""
            }`}
            aria-labelledby="alertsDropdown"
          >
            <h6 className="dropdown-header">Alerts Center</h6>
            <Link
              to="/dashboard"
              className="dropdown-item d-flex align-items-center"
            >
              <div className="mr-3">
                <div className="icon-circle bg-primary">
                  <i className="fas fa-file-alt text-white"></i>
                </div>
              </div>
              <div>
                <div className="small text-gray-500">December 12, 2019</div>
                <span className="font-weight-bold">
                  A new monthly report is ready to download!
                </span>
              </div>
            </Link>

            <button className="btn dropdown-item text-center small text-gray-500">
              Show All Alerts
            </button>
          </div>
        </li>

        <div className="topbar-divider d-none d-sm-block"></div>

        {/* <!-- Nav Item - User Information --> */}
        <li
          className={`nav-item dropdown no-arrow ${
            showProfile ? "show" : "false"
          }`}
        >
          <button
            className="btn nav-link dropdown-toggle"
            aria-haspopup="true"
            aria-expanded={showProfile ? "true" : "false"}
            onClick={() => setShowProfile(!showProfile)}
          >
            <span className="mr-2 d-none d-lg-inline text-gray-600 small">
              Valerie Luna
            </span>
            <img
              className="img-profile rounded-circle"
              alt="my display profile "
              src="https://source.unsplash.com/QAB-WJcbgJk/60x60"
            />
          </button>
          {/* <!-- Dropdown - User Information --> */}
          <div
            className={`dropdown-menu dropdown-menu-right shadow animated--grow-in ${
              showProfile ? "show" : "false"
            }`}
            aria-labelledby="userDropdown"
          >
            <Link to="/dashboard" className="dropdown-item">
              <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
              Profile
            </Link>
            <Link to="/dashboard/setting" className="dropdown-item">
              <i className="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
              Settings
            </Link>

            <div className="dropdown-divider"></div>
            <button
              className="dropdown-item"
              type="button"
              onClick={signOutHandler}
            >
              <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
              Logout
            </button>
          </div>
        </li>
      </ul>
    </nav>
  );
};
export default Topbar;
